// extracted by mini-css-extract-plugin
module.exports = {"quoteText":"_3qPGA","quoteLeft":"_2Pfs-","quoteRight":"_2Fv4q"};